import React from 'react';
import './Tagline.scss';

export const Tagline = ({ tagline, Tag = 'span' }) => {
  if (!tagline) return null;
  return <Tag className="tagline">{tagline}</Tag>;
};
